import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

import './FilterAvailability.scss';

export const availabilityChoices =  [
  {text: 'Tous'},
  {value: 0, text: 'Immédiate'},
  {value: 1, text: '1 mois'},
  {value: 2, text: '2 mois'},
  {value: 3, text: '3 mois'},
]

export default class Filter extends Component {
  static propTypes = {
    value: PropTypes.any,
  };

  static defaultProps = {
    value: '',
  };

  constructor(props) {
    super(props);
    this.choices = [
      {text: 'Tous'},
      {value: 0, text: 'Immédiate'},
      {value: 1, text: '1 mois max'},
      {value: 2, text: '2 mois max'},
      {value: 3, text: '3 mois max'},
    ];

    this.state = {
      showDrop: false,
      value: props.value,
      title: this.getTitle(props.value)
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (!isNaN(this.props.value) && this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value,
        title: this.getTitle(this.props.value)
      })
    } else if (isNaN(this.props.value) && !isNaN(prevProps.value)) {
      this.setState({
        value: undefined,
        title: 'Disponibilité'
      })
    }
  }

  dropdownToggle = () => {
    this.setState({showDrop: !this.state.showDrop});
  };

  onChange = (value) => {
    this.setState({
      value: value,
      title: this.getTitle(value.value)
    });
    this.props.onChange(value.value);
  };

  getTitle = (value) => {
    for (
      let i = 0, sz = this.choices.length;
      value !== undefined && i < sz;
      i++
    ) {
      if (this.choices[i]['value'] === value) {
        return this.choices[i]['text'];
      }
    }

    return 'Disponibilité';
  };

  render() {
    return (
      <div>
        <Dropdown
          className="filter-dropdown"
          isOpen={this.state.showDrop}
          toggle={() => this.dropdownToggle()}>
          <DropdownToggle caret color="link">
            {this.state.title}
          </DropdownToggle>
          <DropdownMenu
            className={this.state.showDrop ? 'show' : ''}
          >
            {this.choices.map((value, id) => (
              <DropdownItem
                key={id}
                onClick={() => this.onChange(value)}
              >
                {value?.text ?? ''}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  }
}